import { FC, useState, createContext } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AppHeader } from './components/AppHeader';
import { AccountNumberReq } from './types/types';
import { AppRouter } from './Routes';
import './App.css';

export const AppContext = createContext<{
  accountNumberReq: AccountNumberReq;
  setAccountNumberReq: (accountNumberReq: AccountNumberReq) => void;
}>({
  accountNumberReq: {
    accountNumber: '0',
    uuid: '',
    token: '',
    lastName: '',
    dateOfBirth: '',
    postcode: '',
    fileTye: '',
    creditorDocType: '',
    incomeDocType: '',
  },
  setAccountNumberReq: (accountNumberReq: AccountNumberReq) => ({})
});

export const App: FC = () => {
  const [accountNumberReq, setAccountNumberReq] = useState<AccountNumberReq>({
    accountNumber: '0',
    uuid: '',
    token: '',
    lastName: '',
    postcode: '',
    dateOfBirth: '',
    fileTye: '',
    creditorDocType: '',
    incomeDocType: ''
  });
  return (
    <AppContext.Provider value={{ accountNumberReq, setAccountNumberReq }}>
      <Router>
        <AppHeader />
        <AppRouter />
      </Router>
    </AppContext.Provider >
  );

}

export default App;
